import { render } from "./LeaveCarryForwardStatusPage.vue?vue&type=template&id=72fea595"
import script from "./LeaveCarryForwardStatusPage.vue?vue&type=script&lang=js"
export * from "./LeaveCarryForwardStatusPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__